import axios from "axios";
import { API_URL } from "src/scenes/App";

export const getCompanyInformation = async (user) => {
    const response = await axios.get(`${API_URL}/company`, {
        headers: {
            Authorization: "Bearer " + user.token
        }
    });
    return response.data;
};

export const getQuotes = async (user, companyUuid) => {
    const response = await axios.get(`${API_URL}/company/myquotes/${companyUuid}`, {
        headers: {
            Authorization: "Bearer " + user.token
        }
    });
    return response.data;
};

export const getSettings = async (user) => {
    const response = await axios.get(`${API_URL}/company/settings`, {
        headers: {
            Authorization: "Bearer " + user.token
        }
    });
    return response.data;
};